/**
 * Model (DTO) reprezentujący określony zakres czasu w obrębie konkretnego dnia tygodnia.
 * Służy do nakładania zaawansowanych reguł kalendarzowych (np. rezerwacje
 * tylko telefoniczne) na wybrane bloki godzinowe w harmonogramie kliniki.
 */
export class ReservationDhJsonDashboard {

  /** Indeks dnia tygodnia (Day Index).
   */
  public dayIdx: number;

  /** Czas rozpoczęcia obowiązywania reguły.
   * Przechowywany jako ciąg znaków, w formacie 24-godzinnym "HH:mm" (np. "08:00").
   */
  public startTime: string;

  /** Czas zakończenia obowiązywania reguły.
   * Przechowywany jako ciąg znaków (np. "16:30").
   */
  public endTime: string;

  /** Flaga ułatwiająca konfigurację (Full Day Toggle).
   * Jeśli ustawiona na true, system ignoruje pola startTime oraz endTime
   * i automatycznie aplikuje daną regułę na całą dobę dla wybranego dnia.
   * Bardzo przydatne np. do oznaczania wszystkich niedziel jako dni tylko telefoniczne.
   */
  public isFullDay: boolean;

  constructor() {
  }

}
